import { render, staticRenderFns } from "./QuoteBuilderLabourComponent.vue?vue&type=template&id=05e16174"
import script from "./QuoteBuilderLabourComponent.vue?vue&type=script&lang=js"
export * from "./QuoteBuilderLabourComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports